<template>
  <el-dialog
    ref="dialogs"
    :visible.sync="dialogVisible"
    :width="dialogSize"
    :modal="mask"
    top="0"
    :append-to-body="appendToBody"
    :modal-append-to-body="appendTo ? false : modalAppendToBody"
    :close-on-click-modal="closeOnModal"
    :close-on-press-escape="closeOnEsc"
    :show-close="false"
    :class="{
      'dialog-header-border': title,
      'dialog-body-padding': $slots.footer || footer
    }"
    :custom-class="`dialog-position-${position} dialog-size-${width}`"
  >
    <template v-if="!destroyOnClose || (destroyOnClose && dialogVisible)">
      <!-- 标题 -->
      <div class="dialogs-title" v-if="title">{{ title }}</div>
      <!-- 关闭按钮 -->
      <div class="dialogs-close" v-if="closeShow" @click="close">
        <img :src="closeImg" alt="">
      </div>
      <!-- 默认插槽 -->
      <div
        class="dialogs-contant"
        :style="`padding: ${padding}px`"
        v-if="$slots.default"
      >
        <slot></slot>
      </div>
      <!-- 预设模板，左右结构 -->
      <div v-if="$slots.left && $slots.right" class="dialogs-lr">
        <div class="dialogs-left">
          <slot name="left"></slot>
        </div>
        <div class="dialogs-right">
          <slot name="right"></slot>
        </div>
      </div>
      <!-- footer插槽 -->
      <div class="dialogs-footer" v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>
      <div class="dialogs-footer" v-else-if="footer">
        <el-button @click="close" v-if="cancelShow">{{ cancelText }}</el-button>
        <el-button
          type="primary"
          :loading="confirmLoading"
          @click="confirm"
          v-if="confirmShow"
          >{{ confirmText }}</el-button
        >
      </div>
    </template>
  </el-dialog>
</template>

<script>
// import { Dialog } from 'element-ui';
import closeImg from '@imgs/icon_close1@2x.png';

export default {
  name: "Dialog",
  components: {
    // 'el-dialog': Dialog,
  },
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    // 指定挂载节点
    appendTo: {
      type: String,
      default: ""
    },
    // 弹窗开关
    visible: {
      type: Boolean,
      default: false
    },
    // 内边距
    padding: {
      type: [Number, String],
      default: 20
    },
    // 是否显示关闭按钮
    closeShow: {
      type: Boolean,
      default: true
    },
    // 底部栏
    footer: {
      type: Boolean,
      default: true
    },
    // 确认按钮
    confirmShow: {
      type: Boolean,
      default: true
    },
    // 确认按钮loading
    confirmLoading: {
      type: Boolean,
      default: false
    },
    // 确认按钮文字
    confirmText: {
      type: String,
      default: "确定"
    },
    // 取消按钮
    cancelShow: {
      type: Boolean,
      default: true
    },
    // 取消按钮文字
    cancelText: {
      type: String,
      default: "取消"
    },
    // 弹窗标题
    title: {
      type: String,
      default: ""
    },
    // 弹窗大小: small, middle, big，也支持固定px和百分比
    width: {
      type: String,
      default: "middle"
    },
    // 弹窗位置，目前都是居中，其它情况，后续再加
    position: {
      type: String,
      default: "center"
    },
    // 是否需要遮罩层
    mask: {
      type: Boolean,
      default: true
    },
    // Dialog 自身是否插入至 body 元素上，嵌套dialog需要设置为true
    appendToBody: {
      type: Boolean,
      default: true
    },
    // 遮罩层是否插入至body，若false，则插入至dialog的父元素
    modalAppendToBody: {
      type: Boolean,
      default: true
    },
    // 是否可以通过点击 modal 关闭 Dialog
    closeOnModal: {
      type: Boolean,
      default: false
    },
    // 是否可以通过按下 ESC 关闭 Dialog
    closeOnEsc: {
      type: Boolean,
      default: true
    },
    // 关闭时是否销毁Dialog中的元素
    destroyOnClose: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      closeImg,
      dialogVisible: false, // 开关
      dialogSize: "" // 弹窗大小
    };
  },
  created() {
    // 弹窗大小
    switch (this.width) {
      case "small":
        this.dialogSize = "320px";
        break;
      case "middle":
        this.dialogSize = "750px";
        break;
      case "big":
        this.dialogSize = "1000px";
        break;
      default:
        this.dialogSize = this.width || "750px";
        break;
    }
  },
  mounted() {
    if (this.appendTo) {
      document.querySelector(this.appendTo).appendChild(this.$el);
    }
  },
  beforeDestroy() {
    if (this.appendTo) {
      document.querySelector(this.appendTo).removeChild(this.$el);
    }
  },
  watch: {
    // 弹窗开关
    visible: {
      handler(val) {
        this.dialogVisible = val;
      },
      immediate: true
    },
    dialogVisible(val) {
      // 支持v-model，支持.sync
      this.$emit("change", val);
      this.$emit("update:visible", val);
    }
  },
  methods: {
    // 点击确认
    confirm() {
      this.$emit("confirm");
    },
    // 点击取消
    close() {
      this.$emit("close");
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>

.dialogs-title {
  color: #333;
  font-weight: bold;
  font-size: 16px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  height: 50px;
  box-sizing: border-box;
  border-bottom: 1px solid #e4e4e4;
}
.dialogs-close {
  width: 14px;
  height: 14px;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  &:hover {
    opacity: 0.8;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
::v-deep .el-button {
  min-width: 100px;
}
::v-deep .el-dialog {
  margin: 0;
  border-radius: 4px;
  box-sizing: border-box;
  max-height: 90vh;
  overflow: hidden;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
    box-sizing: border-box;
    .dialogs-contant {
      overflow-y: auto;
      height: 100%;
      box-sizing: border-box;
    }
    .dialogs-lr {
      display: flex;
      align-items: stretch;
      box-sizing: border-box;
      height: 90vh;
      overflow: hidden;
      .dialogs-left {
        border-right: 1px solid #e4e4e4;
        width: 261px;
        box-sizing: border-box;
        overflow-y: auto;
        height: 100%;
        .left-title {
          font-size: 20px;
          color: #333;
          font-weight: 500;
          box-sizing: border-box;
          padding: 20px 20px;
        }
        .left-search {
          width: 200px;
          box-sizing: border-box;
          margin: 0 20px 20px 20px;
          border-radius: 4px;
          .el-input__inner {
            &:focus {
              border-color: $theme;
            }
          }
          .el-input__prefix .el-input__icon {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .left-list {
          max-height: calc(100% - 127px);
          box-sizing: border-box;
          overflow-y: auto;
          margin: 0;
        }
      }
      .dialogs-right {
        flex: 1;
        overflow-y: auto;
        box-sizing: border-box;
        height: 100%;
        .right-title {
          font-size: 16px;
          color: #333;
          font-weight: 500;
          box-sizing: border-box;
          padding: 0 20px;
          height: 50px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #e4e4e4;
        }
      }
    }
    .dialogs-footer {
      display: flex;
      align-items: center;
      height: 60px;
      box-sizing: border-box;
      background-color: #fff;
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
    }
  }
}
::v-deep .dialog-position {
  &-center {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
}
::v-deep .dialog-size {
  &-small {
    .el-dialog__body {
      .dialogs-contant {
        padding: 20px;
        text-align: center;
        & .small-img {
          width: 50px;
          height: 50px;
          margin: 0 0 10px 0;
        }
        & .small-title {
          font-size: 16px;
          color: #333;
          font-weight: 500;
          margin: 0 0 10px 0;
        }
        & .small-tip {
          font-size: 14px;
          color: #888;
          font-weight: 400;
          margin: 0 0 10px 0;
        }
      }
      .dialogs-footer {
        padding: 0 20px;
        height: 80px;
        justify-content: center;
        .el-button {
          min-width: 135px;
        }
      }
    }
  }
  &-middle {
    // height: 90vh;
    .el-dialog__body {
      .dialogs-footer {
        padding: 0 20px;
        justify-content: flex-end;
      }
    }
  }
  &-big {
    height: 90vh;
    .el-dialog__body {
      height: 100%;
      .dialogs-footer {
        justify-content: flex-end;
        padding: 0 20px;
      }
    }
  }
}
.dialog-header-border {
  ::v-deep .el-dialog__body {
    .dialogs-contant {
      height: auto;
      max-height: calc(90vh - 50px);
    }
    .dialogs-lr {
      height: auto;
      max-height: calc(90vh - 50px);
    }
  }
}
.dialog-body-padding {
  ::v-deep .el-dialog__body {
    padding-bottom: 60px;
    .dialogs-contant {
      max-height: calc(90vh - 60px);
    }
    .dialogs-lr {
      max-height: calc(90vh - 60px);
    }
  }
  ::v-deep .dialog-size-small {
    .el-dialog__body {
      padding-bottom: 80px;
      .dialogs-contant {
        max-height: calc(90vh - 80px);
      }
    }
  }
}
.dialog-header-border.dialog-body-padding {
  ::v-deep .el-dialog__body {
    .dialogs-contant {
      height: auto;
      max-height: calc(90vh - 110px);
    }
    .dialogs-lr {
      height: auto;
      max-height: calc(90vh - 110px);
    }
  }
}
</style>
